module.exports = __webpack_public_path__ + "img/icon_check.f05d8ce8.png";